import axios from "axios";

const URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002'; // Fallback to localhost if not set
// User API functions    


// Get all reminders by an array of practiceNumbers that are of a specific type
export async function getReminderPreferencesByPracticeNumbers(practiceNumbers, type) {
  try {
    const response = await axios.post(`${URL}/comms/remindersByPracticeNumbers`, {
      practiceNumbers,
      type,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching aged invoices:", error.response?.data || error.message);
    throw error;
  }
}

export async function createReminder(reminder) {
    try {
      const response = await axios.post(`${URL}/comms`,reminder);
      return response.data;
    } catch (error) {
      console.error("❌ Error creating smsReminder:", error.response?.data || error.message);
      throw error;
    }
  }

  export async function updateReminder(id, reminder) {
    try {
      const response = await axios.put(`${URL}/comms/${id}`, reminder);
      return response.data;
    } catch (error) {
      console.error("❌ Error updating SMSReminder:", error.response?.data || error.message);
      throw error;
    }
  }

export async function getSMSReminderByPracNumber(practiceNumber) {
  try {
    const response = await axios.post(
      `${URL}/comms/SMSbyPracticeNumber`,
      { practiceNumber: String(practiceNumber) }
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ Error fetching SMS reminder by practice number:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export async function createOnlineBooking(bookingDetail) {
    try {
      const response = await axios.post(`${URL}/booking`, bookingDetail);
      return response.data;
    } catch (error) {
      console.error("❌ Error creating smsReminder:", error.response?.data || error.message);
      throw error;
    }
  }

  export async function updateOnlineBooking(id, bookingDetail) {
    try {
      const response = await axios.put(`${URL}/booking/${id}`, bookingDetail);
      return response.data;
    } catch (error) {
      console.error("❌ Error updating SMSReminder:", error.response?.data || error.message);
      throw error;
    }
  }

  // Get all reminders by an array of practiceNumbers that are of a specific type
export async function getOnlineBookingSettings(practiceNumbers) {
  try {
    const response = await axios.post(`${URL}/onlinebookingsettings`, {
      practiceNumbers,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching aged invoices:", error.response?.data || error.message);
    throw error;
  }
}

export async function getOnlineBooking(id) {
  try {
    const response = await axios.post(`${URL}/booking/byid`, {
      id,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching aged invoices:", error.response?.data || error.message);
    throw error;
  }
}

